import { TypePolicies } from '@apollo/client'
import { relayStylePagination } from '@apollo/client/utilities'

export const conversationsCacheConfig: TypePolicies = {
  User: {
    fields: {
      conversations: relayStylePagination(['archived', 'favoritesOnly', 'listingId']),
    },
  },
}

export const interactionsCacheConfig: TypePolicies = {
  Conversation: {
    fields: {
      interactions: relayStylePagination(),
      messages: relayStylePagination(),
    },
  },
}
